import { Icon } from '@shopify/polaris';
import {
  CatalogIcon,
  ChartVerticalIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ClipboardChecklistIcon,
  DeliveryIcon,
  HomeIcon,
  OrderIcon,
  SettingsIcon,
  XIcon,
} from '@shopify/polaris-icons';
import { PakoLogo } from '../components/PakoLogo';
import { SETTINGS_NAV_CHILDREN } from '../lib/adminRoutes';

export const NAV_ITEMS = [
  { key: 'overview', label: 'Огляд', path: '/overview' },
  { key: 'sync', label: 'Синхронізація', path: '/sync' },
  { key: 'catalog', label: 'Каталог', path: '/catalog' },
  { key: 'orders', label: 'Замовлення й оплати', path: '/orders-payments' },
  { key: 'nova-poshta-orders', label: 'Нова Пошта замовлення', path: '/nova-poshta-orders' },
  {
    key: 'settings',
    label: 'Налаштування',
    path: '/settings',
    children: SETTINGS_NAV_CHILDREN,
  },
  { key: 'logs', label: 'Журнал', path: '/logs' },
];

const ICON_BY_KEY: Record<string, any> = {
  overview: HomeIcon,
  sync: ChartVerticalIcon,
  catalog: CatalogIcon,
  orders: OrderIcon,
  'nova-poshta-orders': DeliveryIcon,
  settings: SettingsIcon,
  logs: ClipboardChecklistIcon,
};

export function Sidebar({
  currentPath,
  onNavigate,
  isOpen = false,
  onClose,
  role,
  onLogout,
}: {
  currentPath: string;
  onNavigate: (path: string) => void;
  isOpen?: boolean;
  onClose?: () => void;
  role?: 'admin' | 'viewer' | null;
  onLogout: () => void;
}) {
  const isSettingsPath = currentPath === '/settings' || currentPath.startsWith('/settings/');
  const roleText = role === 'viewer' ? 'Перегляд' : 'Адмін';

  return (
    <aside className={`admin-sidebar ${isOpen ? 'is-open' : ''}`} aria-label="Навігація">
      <div>
        <div className="admin-sidebar__brand">
          <div className="admin-sidebar__logo">
            <PakoLogo size={36} />
          </div>
          <div className="admin-sidebar__brand-copy">
            <div className="admin-sidebar__title">Pako AdminApp</div>
          </div>
          <button
            type="button"
            className="admin-sidebar__close"
            onClick={onClose}
            aria-label="Закрити меню"
          >
            <Icon source={XIcon} />
          </button>
        </div>
        <nav className="admin-sidebar__nav">
          {NAV_ITEMS.map((item) => {
            const hasChildren = Boolean((item as any).children?.length);
            const isActive = hasChildren
              ? isSettingsPath
              : currentPath === item.path;
            const isOpen = hasChildren && isSettingsPath;

            return (
              <div key={item.key} className="admin-sidebar__item">
                <button
                  type="button"
                  className={`admin-sidebar__link ${isActive ? 'is-active' : ''}`}
                  aria-expanded={hasChildren ? isOpen : undefined}
                  onClick={() => {
                    onNavigate(item.path);
                    if (!hasChildren) {
                      onClose?.();
                    }
                  }}
                >
                  <span className="admin-sidebar__link-icon">
                    <Icon source={ICON_BY_KEY[item.key]} />
                  </span>
                  <span className="admin-sidebar__link-label">{item.label}</span>
                  {hasChildren ? (
                    <span className="admin-sidebar__link-disclosure" aria-hidden="true">
                      <Icon source={isOpen ? ChevronUpIcon : ChevronDownIcon} />
                    </span>
                  ) : null}
                </button>
                {hasChildren && isOpen ? (
                  <div className="admin-sidebar__children">
                    {(item as any).children.map((child: any) => (
                      <button
                        key={child.key}
                        type="button"
                        className={`admin-sidebar__child-link ${currentPath === child.path ? 'is-active' : ''}`}
                        onClick={() => {
                          onNavigate(child.path);
                          onClose?.();
                        }}
                      >
                        {child.label}
                      </button>
                    ))}
                  </div>
                ) : null}
              </div>
            );
          })}
        </nav>
      </div>
      <div className="admin-sidebar__footer">
        <span className="admin-sidebar__role">Роль: {roleText}</span>
        <button type="button" className="admin-sidebar__logout" onClick={onLogout}>
          Вийти
        </button>
      </div>
    </aside>
  );
}
